<template>
  <div>
    <FiltersAduanas
      :filtersView="filterView"
      :has-query-filters="!!queryFilters"
      :clear-query-filters="clear"
      v-on:filtros-aplicados="changeFilters"
    />
  </div>
</template>
<script>

import { mapGetters } from 'vuex';

import FiltersAduanas from '@/febos/global/_vue/componentes/filtersLetty/aduanas/FiltersAduanas';
import ConfigReceiptsFiltersMixin from '@/febos/global/_vue/componentes/filtersLetty/aduanas/ConfigReceiptsFiltersMixin';
import { getShareableFilters } from '@/febos/chile/dnt/utils/fitlers';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';

export default {
  components: { FiltersAduanas },
  props: ['value', 'onChange', 'clear', 'defaultDate'],
  mixins: [ConfigReceiptsFiltersMixin],
  data() {
    const { name } = this.$route;
    return {
      view: name,
      currentFilters: '',
      queryFilters: this.$route.query.filters
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company',
      'usersCompany'
    ]),
    configuration() {
      return this.getFilterView(this.view);
    },
    filterView() {
      return this.getFilterView(this.view);
    }
  },
  methods: {
    async changeFilters(filters, onMounted) {
      this.currentFilters = filters;
      const defaultFilters = 'deshabilitado:no';
      const newFilters = filters !== ''
        ? `${defaultFilters}|${filters}`
        : defaultFilters;

      if (!onMounted) {
        const nonShareableFilters = [
          // TODO: agregar campo de busqueda de coincidencias
          ...(this.configuration.filtrosFijos || []).map((filterConfig) => filterConfig.campo)
        ];
        const queryFilters = getShareableFilters(newFilters, nonShareableFilters);
        updateSearchParams({ filters: queryFilters });
      }
      this.onChange(newFilters, onMounted);
    },
    clearQueryFilters() {
      removeSearchParams(['filters']);
      // TODO: try to change to default filter state for current view.
      this.$router.go();
    }
  }
};

</script>
<style>
.input-date {
  border: 1px solid #bcbcbc;
  padding: 6px 8px;
  border-radius: 5px;
}
.search-bar {
  align-items: baseline;
  width: 50%;
}
</style>
